import actionTypes from '../actionTypes';

export function requestCareerData ({ type, productId, dateFrom, dateTo, skinId }) {
    return {
      type: actionTypes.CAREER_DATA_REQUEST,
      value: { type, productId, dateFrom, dateTo, skinId }
    };
  }
  
export function successCareerData ( careerData ) {
    return {
        type: actionTypes.CAREER_DATA_SUCCESS,
        careerData
    };
}

export function failCareerData ({ }) {
    return {
        type: actionTypes.CAREER_DATA_FAILURE
    };
}

export function toggleCareerMenu () {
    return {
        type: actionTypes.TOGGLE_CAREER_MENU,
    }
}